export default "__VITE_ASSET__CHD0IwGh__";